// components/Sidebar.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FiLogOut,
  FiGrid,
  FiPackage,
  FiShoppingBag,
  FiUsers,
  FiLayers,
  FiUser,
  FiTag,
  FiImage,
} from "react-icons/fi";

const Sidebar = ({
  auth,
  activeTab,
  setActiveTab,
  setSidebarOpen,
  onLogout,
}) => {
  const navigate = useNavigate();

  const navigationItems = [
    {
      id: "overview",
      icon: FiGrid,
      label: "Overview",
      onClick: () => navigate("/dashboard/admin"),
    },
    {
      id: "products",
      icon: FiLayers,
      label: "Products",
      onClick: () => navigate("/dashboard/admin/products"),
    },
    {
      id: "orders",
      icon: FiPackage,
      label: "Orders",
      onClick: () => navigate("/dashboard/admin/orders"),
    },
    {
      id: "banners",
      icon: FiImage,
      label: "Banners",
      onClick: () => navigate("/dashboard/admin/banners"),
    },
    {
      id: "users",
      icon: FiUsers,
      label: "Users",
      onClick: () => navigate("/dashboard/admin/users"),
    },
    {
      id: "coupons",
      icon: FiTag,
      label: "Coupons",
      onClick: () => navigate("/dashboard/admin/coupons"),
    },
    {
      id: "categories",
      icon: FiShoppingBag,
      label: "Categories",
      onClick: () => navigate("/dashboard/admin/category"),
    },
    {
      id: "profile",
      icon: FiUser,
      label: "Profile",
      onClick: () => navigate("/dashboard/user/profile"),
    },
  ];

  // Helper to handle clicks consistently across Mobile and Desktop
  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    } else {
      setActiveTab(item.id);
      setSidebarOpen(false);
    }
  };

  return (
    <>
      {/* DESKTOP SIDEBAR (100% Original Code - Hidden on Mobile) */}
      <div className="hidden lg:block rounded-lg shadow-sm p-6 sticky top-6 bg-white border border-gray-200 ">
        {/* Admin Profile */}
        <div className="mb-8 pb-6 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-lg bg-gray-900 flex items-center justify-center text-white text-2xl font-bold">
              {auth?.user?.name?.charAt(0).toUpperCase()}
            </div>
            <div>
              <h3 className="text-gray-900 font-bold text-lg">
                {auth?.user?.name}
              </h3>
              <p className="text-gray-400 text-sm">Administrator</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="space-y-2">
          {navigationItems.map((item) => (
            <button
              key={item.id}
              className={`w-full flex items-center gap-3 py-3 px-4 transition-all duration-200 ${
                activeTab === item.id
                  ? "text-gray-900 font-semibold border-b-2 border-gray-600"
                  : "text-gray-400 border-b border-gray-200 hover:text-gray-600 hover:bg-gray-50"
              }`}
              onClick={() => handleItemClick(item)}
            >
              <item.icon size={20} />
              {item.label}
            </button>
          ))}
        </nav>

        {/* Logout Button */}
        <button
          onClick={onLogout}
          className="w-full mt-8 flex items-center justify-center gap-3 py-3 px-4 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-900 font-semibold transition-all duration-200"
        >
          <FiLogOut size={20} />
          Logout
        </button>
      </div>

      {/* MOBILE/TABLET BOTTOM NAV (Always Open - New "Hatke" Design) */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe z-50">
        <div className="flex items-center justify-between px-2 py-2">
          {navigationItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleItemClick(item)}
              className={`flex flex-col items-center justify-center w-full py-2 rounded-lg transition-colors ${
                activeTab === item.id
                  ? "text-gray-900"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <div
                className={`p-1.5 rounded-full mb-1 transition-all ${
                  activeTab === item.id
                    ? "bg-gray-900 text-white"
                    : "bg-transparent"
                }`}
              >
                <item.icon
                  size={20}
                  strokeWidth={activeTab === item.id ? 2.5 : 2}
                />
              </div>
              <span className="text-[10px] font-medium truncate max-w-[60px]">
                {item.label}
              </span>
            </button>
          ))}

          {/* Mobile Logout (Icon Only to save space) */}
          {/* <button
            onClick={onLogout}
            className="flex flex-col items-center justify-center w-full py-2 text-red-400 hover:text-red-600"
          >
            <div className="p-1.5 mb-1">
              <FiLogOut size={20} />
            </div>
            <span className="text-[10px] font-medium">Logout</span>
          </button> */}
        </div>
      </div>

      {/* Spacer to prevent content from hiding behind bottom nav on mobile */}
  
    </>
  );
};

export default Sidebar;
